import React from 'react';

import clsx from 'clsx';
import { Accept, useDropzone } from 'react-dropzone';
import { Box, Typography, makeStyles, Theme, createStyles } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';

interface Props {
  onDrop: (files: File[]) => void;
  accept?: Accept;
  label?: string;
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
}

// Files dropped anywhere on a chat are attached to the next message.
export const ChatDropZone: React.FC<Props> = ({
  onDrop,
  accept,
  label = 'Drop files here to send them',
  disabled,
  className,
  children,
}) => {
  const classes = useStyles();
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept,
    noClick: true,
    noKeyboard: true,
    disabled,
    onDrop,
  });

  return (
    <Box {...getRootProps({ className: clsx(classes.root, className) })}>
      <input {...getInputProps()} />
      {children}
      <Box
        className={clsx(classes.drop, { [classes.dropActive]: isDragActive })}
        aria-hidden={!isDragActive}
      >
        <Typography variant="h6">{label}</Typography>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: { position: 'relative', outline: 'none' },
    drop: {
      position: 'absolute',
      inset: 8,
      zIndex: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 16,
      border: `2px dashed ${theme.palette.primary.main}`,
      backgroundColor: alpha(theme.palette.background.default, 0.9),
      color: theme.palette.primary.main,
      opacity: 0,
      pointerEvents: 'none',
      transition: 'opacity 120ms',
    },
    dropActive: { opacity: 1 },
  })
);
